import { render, staticRenderFns } from "./CounterTicketDisplayForm.vue?vue&type=template&id=b981dea2&"
import script from "./CounterTicketDisplayForm.vue?vue&type=script&lang=js&"
export * from "./CounterTicketDisplayForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports